// extracted by css-extract-rspack-plugin
export default {"proLabel":"GlobalCopilotMenu-module__proLabel__Gyv3w"};